import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useAddReportTypeMutation, useUpdateReportTypeMutation } from "../../Data/services/reportTypeApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import _ from "lodash";

const EditReportTypeModal = ({ handleEditModalClose, editData, refetch }) => {
  const [rowId, setRowId] = useState("");
  const [reportType, setReportType] = useState("");
  const [sending, setSending] = useState(false);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // console.log(data.business_title);
    // console.log(data.slug);
    if (editData) {
      setRowId(editData.slug);
      setReportType(editData.name);
    }
  }, [editData, mounted]);



  const handleReportTitile = (e) => {
    console.log(e.target.value);
    setReportType(e.target.value);
  };

  const [addReportType, { isLoading: adding }] = useAddReportTypeMutation();
  const [updateReportType, { isLoading: updating }] =
    useUpdateReportTypeMutation();

  const handleSubmit = async (e) => {
    console.log(rowId);
    console.log(reportType);
    if (reportType.length <= 2 || _.isEmpty(reportType)) {
      Toast("Minimum 3 characters required.", "error");
      return;
    }
    const data = {
      name: reportType,
    };

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updateReportType({ data, slug: rowId });
      } else {
        response = await addReportType(data);
      }

      if (response.data.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.data.message);
        handleEditModalClose();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }

  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit Report Type" : "Add Report Type"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            {
              <Row>
                <Col md={12}>
                  <Input
                    classes="mt-2 mb-3"
                    type="text"
                    placeholder="Enter report type"
                    value={reportType}
                    onChange={handleReportTitile}
                  />
                </Col>
              </Row>
            }

            <Row>
              <Col md={12}>
                <Button
                  classes={`${cssStyles.cardBtn} mt-4 `}
                  text={
                    sending ? (
                      <Spinner
                        animation="grow"
                        size="sm"
                        className="mx-3 my-1"
                      />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditReportTypeModal;
